import React, {useEffect} from "react";
import { ToggleRightIcon, Bell, User, Headphones } from "lucide-react";
import { useNavigate } from "react-router";
import useAuthStore from "../../store/useAuthStore";

const Navbar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate()
  const logoutCustomer = useAuthStore((state) => state.logoutCustomer);
  const userType = useAuthStore((state) => state.userType);

  const handlenav = (path) => {
    navigate(path)
  }

    const handleLogout = () => {
      if (userType === "customer") {
        logoutCustomer();
        navigate("/");
      }
    };
  
    useEffect(() => {
      const handlePopState = () => {
        navigate("/");
      };
  
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }, [navigate]);

  return (
    <div
      className="h-12 flex bg-white justify-between items-center px-2"
      style={{ borderRadius: "8px" }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-white lg:hidden"
      >
        {isOpen ? "" : <ToggleRightIcon color="#000000" size={20} />}
      </button>
      <div className="text-base font-semibold"></div>

      <div className="flex items-center space-x-2">
        <button
          onClick={() => handlenav("/customer/notify")}
          className="w-7 h-7 bg-blue-500 rounded-full flex justify-center items-center"
        >
          <Bell color="#ffffff" size={16} />
        </button>
        
        <button
          onClick={() => handlenav("/customer/help")}
          className="w-7 h-7 bg-blue-500 rounded-full flex justify-center items-center"
        >
          <Headphones color="#ffffff" size={16} />
        </button>

        <button
          onClick={() => handlenav("/customer/profile")}
          className="w-7 h-7 bg-blue-500 rounded-full flex justify-center items-center"
        >
          <User color="#ffffff" size={16} />
        </button>
        {userType === "customer" && (
          <button
            onClick={handleLogout}
            className="w-20 h-8 bg-blue-500 rounded-full flex justify-center items-center transform active:scale-95 transition-transform duration-150"
          >
            {/* <LogOut color="#ffffff" size={16} /> */}
            <span className="text-white text-center">Logout</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Navbar;
